export const trading = {
  等待确认: '確認待ち',
  gas矿工费: 'ガス採掘料金',
  审核扫描: '監査スキャン',
  警报: '警告',
  无警报: '無警告',
  显示更多: 'さらに表示',
  Infos: "これらの監査結果は自動化され、Bikingの外部エンティティによって実施されます。これは推奨ではなく、他の要因と一緒に考慮する必要があります。Bikingはこれらの外部監査人によって取得されたデータの品質を検証または責任を負いません。常に独自の調査を行い、複数の情報源に相談してください。",
  请输数量: '数量を入力してください',
  兑换: '交換',
  价格: '価格',
  选择代币: 'トークンを選択',
  搜索名称或粘贴地址: '名前を検索またはアドレスを貼り付ける',
  DEXT分数: 'DEXTスコア',
  更多检测: 'さらなる検査',
  检查审核: '審査を確認する',
  令牌描述: 'トークンの説明',
  更新: '更新',
  合同验证: '契約の検証',
  买入税: '購入税',
  代理合同: '代理契約',
  可造币: '作成可能なトークン',
  可修改税收: '変更可能な税金',
  转让可暂停: '転送の一時停止が可能',
  黑名单: 'ブラックリスト',
  找回所有权: '所有権の回収',
  可修改余额: '変更可能な残高',
  隐藏的所有者: '隠れた所有者',
  自毁: '自己破壊',
  外部呼叫风险: '外部呼び出しのリスク',
  可以购买: '購入可能',
  最大卖出比率: '最大販売比率',
  白名单: 'ホワイトリスト',
  反鲸鱼可修改: 'ホエールの逆対策が可能',
  交易冷却时间: '取引の冷却時間',
  可修改的个人税收: '変更可能な個人税金',
  真的假的代币: '本物または偽物のトークン',
  空投骗局: 'エアドロップ詐欺',
  可以信任: '信頼できる',
  业主地址: 'オーナーアドレス',
  所有者余额: 'オーナーの残高',
  业主百分比: 'オーナーの割合',
  创建者地址: '作成者のアドレス',
  创造者余额: '作成者の残高',
  创造者百分比: '作成者の割合',
  配对持有者: 'ペアの所有者',
  其他风险: 'その他のリスク',
  注意: '注意',
  交易: '貿易',
  kpsj: '開始時間',
  jlks: '開始までの時間',
  t: '日',
  s: '時',
  f: '分',
  m: '秒',

  zgj: '最高値：',
 zdj: '最安値：',
 gflj: '公式リンク',
 gw: '公式ウェブサイト',
 qkllq: 'ブロックエクスプローラー',
 scfxsj: '初回発行時間',
 fxzl: '発行総量',
 ltzl: '流通総量',
 jy: '取引',
 sj: '市場価格',
 tbxx: 'チャート情報',
 bzgk: '通貨概要',
 jcb: '基本版',
 ddb: '注文表',
 zxcj: '最新取引',
  
 reload: "更新",
 socketError: "ネットワークエラー、",
 noData: "データなし",
 entrustorder: "板",
 prices: "価格",
 quantity: "数量",
 grandtotal: "累計",
 transamount: "取引額",
 time: "時間",
 available: "利用可能",
 limitorder: "指値注文",
 plancommission: "トリガー注文",
 currentcommission: "注文",
 historycommission: "過去の注文",
 completecommission: "完了した注文",
 funds: '資金',
 hidetrading: "他のペアを非表示",
 morecurrentcommission: "その他の現在の注文",
 morehistorycommission: "その他の過去の注文",
 moredocommission: "その他の完了した注文",
 realtimetrans: "リアルタイム取引",
 myassets: "私の資産",
 detail: "詳細",
 buyin: "購入",
 sellout: "売却",
 login: "ログイン",
 transfer: "振替",
 recharge: "入金",
 withdrawal: "コイン購入",
 quickpurchase: "法定通貨でクイック購入",
 default: "デフォルト",
 ordertime: "注文出し時間",
 "windingtime": "チェーンの装着時間",
 tradingpair: "取引ペア",
 direction: "方向",
 types: "タイプ",
 commissionprice: "注文価格",
 commissionnumber: "注文数量",
 dealprice: "取引約定価格",
 dealnumber: "約定数量",
 triggerprice: "トリガー価格",
 cancelall: "すべての注文をキャンセル",
 averageprice: "平均価格",
 totalsum: "合計金額",
 fixedprice: "指値",
 marketprice: "市場価格",
 codeExpired: "QRコードは無効です",
 clickRefresh: "クリックして更新",
 QRsuccessfully: "QRコードのスキャンが成功しました",
 loginInApp: "アプリ内でログインを確認してください",
 backtoQR: "QRコードログインに戻る",
 loginSuccess: "ログイン成功しました、bikingへようこそ！",
 loadingText: "読み込み中...",
 searchPlaceholder: "検索",
 all: "すべて",
 currency: "通貨",
 price: "最新価格",
 market: "上昇率ランキング",
 increase: "上昇率",
 highestPrice: "最高値",
 minimumPrice: "最安値",
 turnover: "出来高",
 jydlb: "トレードペアリスト",
 bzjs: "通貨の紹介",
 currencyTransaction: "現物取引",
 leveragedTransaction: "レバレッジ取引",
 warning:
   "リスク警告：Bitcoin Cashのフォークは非常に不確実性があり、フォーク期間中の未来の価格または価値に関する約束は一切できません。フォーク期間中の投資は非常にリスキーです。フォーク期間中に関連するトークンがゼロになる可能性があります。bikingは一切の責任を負いません。",
 zb: "指標",
 date: "日付",
 UpAnddown: "変動",
 amplitude: "変動幅",
 0: "分",
 1: "1分足",
 5: "5分足",
 15: "15分足",
 30: "30分足",
 60: "1時間足",
 240: "4時間足",
 3600: "1日足",
 10800: "1週間足",
 dates: "期間：",
 password: "取引パスワード",
 errorPassword: "正しい取引パスワードを入力してください",
 worningPassword: "取引パスワードを入力してください",
 cancel: "キャンセル",
 sure: "確認",
 canBuy: "買えます",
 canCell: "売れます",
 withdraw: "出金",
 otc: "OTC、法定通貨スピーディーな入出金",
 enterPrice: "価格を入力してください",
 sellingPrice: "売り価格",
 purchasePrice: "買い価格",
 salesVolume: "売り出し量",
 buyingVolume: "買い入れ量",
 volume: "取引額",
 serviceCharge: "手数料",
 vip: "VIPアップグレード、手数料が割引特典がもらえる",
 or: "または",
 register: "登録",
 totalPrice: "取引額はこの金額を超えることはできません",
 amountTip: "正しい数量を入力してください",
 amountTipError: "この数量を上回ることができません",
 limitTrading: "指値取引",
 priceReminder: "価格リマインダー",
 SMSReminder: "SMSリマインダー",
 loginAccount: "ログインアカウント",
 phone: "携帯電話",
 phoneNum: "携帯電話番号を入力してください",
 phoneTips: "正しい携帯電話番号を入力してください",
 email: "メール",
 emailNum: "メールアドレスを入力してください",
 emailTips: "�正しいメールアドレスを入力してください",
 aears: "国コードを選択してください",
 passwordError: "正しいパスワードを入力してください",
 passwordTips: "パスワードを入力してください",
 forgetPassword: "パスワードを忘れましたか？",
 noAccount: "アカウントがありませんか？",
 goRegister: "今すぐ登録",
 appsys: "APPでQRコードをスキャンして安全にログイン",
 xzapp: "最新のAPPをダウンロード",
 mmdl: "パスワードでログイン",
 smdl: "QRコードでログイン",
 google: "Google認証システム",
 nybd: "あなたは既に登録しています",
 zqyzm: "正しい認証コードを入力してください",
 fsyzm: "認証コードを送信",
 flv: "手数料率",
 jz: "純資産",
 jzdesc1:
   "上昇純資産=前回調整ポイントの純資産*[1+3*(現物最新取引価格-現物前回調整時点の価格)/現物前回調整ポイント価格*100%]；",
 jzdesc2:
   "下落純資産=前回調整ポイントの純資産*[1-3*(現物最新取引価格-現物前回調整時点の価格)/現物前回調整ポイント価格*100%]；",
 sbd: "3倍ロング",
 sbs: "3倍ショート",
 flvjs:
   "ETFファンディングレート、プラットフォームが管理手数料を徴収する割合であり、資金費用を支払うために使用されます。管理料は純資産の変化に反映され、純資産の変化から「対応するETFの価値を差し引く」方式で表示されます。新加坡時間0時にのみ徴収されます。その時間帯に製品を保有しない場合、費用は発生しません。",
 mzsm: "免責事項",
 ido: "私は内容を確認し、同意します",
 exemption1: "お客様、こんにちは！",
 exemption2:
   "BiKingプラットフォーム（BiKing.ai）の提供するレバレッジETF商品と関連サービス（以下「ETF商品」といいます）にアクセスしていただき、ありがとうございます。ETF商品の説明と以下のリスク警告をよくお読みいただき、お読みになった後に引き続きETF商品をご利用いただく場合、ETF商品のリスクを十分に理解し、ETF商品の使用に関連する損失を負担できる能力があり、かつ、本免責事項の全ての内容に同意したものとみなします。以下のETF商品説明をご覧ください。",
 exemption3: "《レバレッジETF商品FAQ》",
 exemption4: "リスク警告：",
 exemption5:
   "1. 購入/売却価格は単位純資産から大きく逸脱しないようにしてください。そうでない場合、相応する損失が発生する可能性があります。",
 exemption6: "2. 判断が誤っている場合、極端な市場状況では価格がほぼゼロになるリスクがあります。",
 exemption7:
   "BiKingプラットフォームは、上記のリスクによる損害や責任について一切責任を負わないことをおしらせもうしあげます。本免責事項は、BiKingプラットフォームとお客様との間でのサービスと商品に関する合意のすべてで構成し、他の規約、声明、ルールと一緒に適用されます。",
 bzjs1: "1、“3L”は基本取引ペアの価格が1%上昇した場合、この商品の純資産は3%上昇します",
 bzjs2: "2、“3S”は基本取引ペアの価格が1%下落した場合、この商品の純資産は3%上昇します",
 bzjs3: "3、純資産は通常、毎日0時に調整されます。極端な市場状況では取引中に調整されることがあります",
 bzjs4: "4、各倍数のレバレッジは日単位で毎日手数料が発生します",
 bzjs5:
   "5、取引前に純資産を注意深く確認してください。極端な市場状況では価格がほぼゼロになるリスクがあります。投資家はリスクを管理するために注意してください。",
 gdjk: "詳細については、アナウンスメントをご覧ください",
 firstTrading: "最初の取引前に取引パスワードを設定してください",
 status: "ステータス",
 status1: "マッチング待ち",
 status2: "未約定",
 status3: "ユーザーキャンセル",
 status4: "一部約定",
 status5: "完全約定",
 status6: "無効",
 allCancel: "全ての注文をキャンセル",
 canceld: "キャンセル",
 cancelsuccess: "全ての注文をキャンセルしました、[*]件の注文がキャンセルされました",
 VIP1: "あなたのVIPランク",
 VIP2: "より低い手数料、より高品質の取引体験",
 VIP3: "テイカー（成行注文）：",
 VIP4: "メーカー（指値注文）：",
 buyAmount: "購入はこの数量を超えてはなりません",
 sellAmount: "売却はこの量を超えてはなりません",
 buyAmountMin: "購入可能残高が不足しています",
 sellAmountMin: "売却可能残高が不足しています",
  
}



// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/ja_JP.js